import { useMemo, useCallback } from "react"
import { useRecoilValue } from "recoil"

import RTMPLink from "./rtmp-link"
import Switch from "../../common/switch"
import { roomSelector, brandingSelector } from "../../../recoil/atoms/room"
import type { ModerationSettingsItemType } from "./moderation.interfaces"
import {
  ModerationSettingsItem,
  ModerationSettingsName
} from "./moderation.styled"
import StreamResolutionSetting from "./streamResolutionSetting"
import useMeetingClient from "../../../hooks/useMeetingClient"

function HighQualityStreamSettings() {
  const meetingClient = useMeetingClient()
  const room = useRecoilValue(roomSelector)
  const roomStyles = useRecoilValue(brandingSelector)

  const proUserSetting = useMemo<ModerationSettingsItemType[]>(
    () => [
      {
        id: "13",
        text: "This computer used for streaming",
        checked: room.rtmpStreamEnable,
        callback: value =>
          meetingClient?.changeRoomSetting({ rtmpStreamEnable: !value })
      },
      {
        id: "14",
        text: "Up to 2 second audience buffering",
        checked: room.audienceBuffering,
        callback: value =>
          meetingClient?.changeRoomSetting({
            audienceBuffering: !value
          })
      }
    ],
    [room.audienceBuffering, room.rtmpStreamEnable, meetingClient]
  )

  const handleSwitch = useCallback(setting => {
    setting.callback(setting.checked)
  }, [])

  if (!room.enableHighQualityStream) return null

  return (
    <>
      <StreamResolutionSetting />
      <RTMPLink />
      {proUserSetting.map(setting => (
        <ModerationSettingsItem key={setting.id}>
          <ModerationSettingsName roomStyles={roomStyles}>
            {setting.text}
          </ModerationSettingsName>
          <Switch
            checked={setting.checked}
            onChange={e => handleSwitch(setting)}
          />
        </ModerationSettingsItem>
      ))}
    </>
  )
}

export default HighQualityStreamSettings
